import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AddCall } from 'src/providers/addvCall';
import { ServicesProvider } from 'src/providers/services';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.page.html',
  styleUrls: ['./payment.page.scss'],
})
export class PaymentPage implements OnInit {
  paymentOption: boolean;
  EnterCardDetailPage: boolean;
  saveCardLabel: boolean;
  presentView: string;
  successValue: string;
  backValue: string;
  goBkVlu: string;
  sendBackValue: string;
  patientBasicDetails: any;
  userEmail: string;
  paystatus: any;

  constructor(private router: Router, private services: ServicesProvider, private activeroute: ActivatedRoute,
    public addCall: AddCall,) { }

  option = {
    slidesPerView: 1.5,
    centeredSlides: true,
    loop: true,
    spaceBetween: 25,
    // autoplay:true,
  }
  ngOnInit() {
  }
  //just temp use 



  ionViewWillEnter() {
    console.log(this.activeroute.snapshot.paramMap.get('paymentstatus'), "=======================================****************");
    this.paystatus = this.activeroute.snapshot.paramMap.get('paymentstatus')
    this.presentView = "paymentSuccess";
    this.successValue = "Payment Successful";
 
    if (this.paystatus == 0) {
      this.successValue = "Booking Successful";
      this.playSound();
    }


    this.userEmail = localStorage.getItem("Email");
    this.goBkVlu = "tabs/" + localStorage.getItem("payBack");
    localStorage.setItem("NopayGoBack", "newEnter");
    if (localStorage.getItem("Reschedule") == "ReschedulePage") {
      localStorage.setItem("NopayGoBack", "ReschedulePage");
      console.log("yes");
      localStorage.setItem("Reschedule", " ");
    }
    setTimeout(() => {
      // this.router.navigate([this.goBkVlu]);
      // this.router.navigate(['tabs/home']);
    }, 5000);
    // this.getPatientBasicDetails();

  }

  /* ionViewWillEnter() {
     this.presentView = "paymentOptionPage";
     this.paymentOption = true;
     this.saveCardLabel = true;
     this.EnterCardDetailPage = false;
     this.successValue = "Success";
     this.backValue = "goHome";
 
     this.goBkVlu = "tabs/" + localStorage.getItem("payBack");
     console.log(this.goBkVlu, " 2Run");
   }*/

  // playAudio() {

  //   let audio = new Audio();
  //   // audio.src = "../../../assets/audio/alarm.wav";
  //   audio.src = "../assets/audio/tick.mp3";
  //   audio.load();
  //   audio.muted = true;
  //   audio.play();

  // }
  
  playSound(){
    let audio = new Audio();
    audio.src="../assets/audio/tick.mp3";
    // audio.load();
    // audio.play();
  }


  EnterCreditCardDetail() {
    this.paymentOption = false;
    this.EnterCardDetailPage = true;
    this.saveCardLabel = false;
    this.backValue = "goPayOpt";
  }
  goBack(value) {
    if (value == "goPayOpt") {
      this.ionViewWillEnter();
    }
    else if (value == "goHome") {
      localStorage.setItem("NopayGoBack", "BookingConPage");
      this.router.navigate([this.goBkVlu]);
    }
    else {
      this.router.navigate([this.goBkVlu]);
    }
  }

  paymentSuccess() {
    this.presentView = "paymentSuccess";
    this.successValue = "Payment Complete";
    localStorage.setItem("NopayGoBack", "newEnter");
    setTimeout(() => { this.router.navigate([this.goBkVlu]); }, 3000);
  }
  BookingConfirm() {
    this.presentView = "paymentSuccess";
    this.successValue = "Booking Confirmed";
    localStorage.setItem("NopayGoBack", "newEnter");

    setTimeout(() => { this.router.navigate([this.goBkVlu]); }, 3000);
  }


  selec() {
    this.presentView = 'check';
  }

  getPatientBasicDetails() {
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": new Date().toISOString().split("T")[0],
      "currentTime": new Date().toTimeString().split(" ")[0]
    });
    console.log("send patient Basic Reqst=>", JSON.parse(apiData));
    this.services.postRequest("getPatientProfile", apiData).subscribe(res => {
      console.log(res);
      this.patientBasicDetails = res.data[0];
    });
  }
}
